import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import * as $ from "jquery/dist/jquery";
import * as M from "materialize-css/dist/js/materialize";
import { Location } from '@angular/common';
import { v4 as uuidv4 } from 'uuid';

import { ResourcesService } from '../resources.service';

@Component({
    selector: 'app-agregar-peso',
    templateUrl: './agregar-peso.component.html',
    styleUrls: ['./agregar-peso.component.css']
})
export class AgregarPesoComponent implements OnInit {

    idcorral: string;
    edadGallina : number = 1;
    prevtitle: string;
    idlote: number = 0;
    user: any = {};
    lote: string;
    aves: number = 0;
    avesArray: any = [{
        peso : 0
    }];
    semana: number = 0;
    semana_offline: any;
    corral: string = '';
    falta_subir: any;
    alert_message: string;
    instance: any;
    mostrarSimulacion: false;
    btnGuardar : boolean = true;
    STD : number = 0;
    standares : any = [];
    tablaSTD : string = '';
    campoSTD : string = '';
    TipoGenero : string = '';
    btnAgregarAves : boolean = false;
    @ViewChild('nombre') nombre;

    constructor(
        private http: HttpClient,
        private route: ActivatedRoute,
        private router: Router,
        public resource: ResourcesService,
        private _location: Location
    ) {

        let user = localStorage.getItem('user')
        this.user = JSON.parse(user);
        if (user == undefined) {
            this.router.navigate(['/']);
            return
        } else {
            this.btnAgregarAves = localStorage.getItem('btnAgregarAves') == "true" ? true : false;
            this.route.paramMap.subscribe(params => {
                this.idlote = Number(params.get('idlote'));
                this.idcorral = params.get('idcorral');
                if (this.user.TipoPesaje == 2) {
                    this.STD = Number(localStorage.getItem('stdPlanta'));
                    this.prevtitle = 'nacimiento'

                    this.http.get(resource.routePlanta+'/nacimiento/nacimientodet-nac/'+this.idcorral).subscribe(
                        (data: any) => {
                            this.corral = data.cabecera[0].CodCarga
                            for (let i = 0; i < data.detalle.length; i++) {
                                const d = data.detalle[i];
                                if(d.idLote == this.idlote){
                                    this.edadGallina = d.edadGallina;
                                }
                            }
                            this.http.get(resource.route + '/semanas/' + this.idcorral).subscribe(
                                (data: any) => {
                                    this.semana = this.edadGallina
                                }
                            );
                        }
                    );
                } else {
                    this.prevtitle = 'corral'

                    // TRAER TODOS LOS CORRALES
                    if (this.idcorral == null) {
                        this.router.navigate(['/lotes']);
                        return;
                    }

                    this.http.get(resource.route + '/corrales/name/' + this.idcorral).subscribe(
                        (data: any) => {
                            this.corral = data[0]['corral']
                        }
                    );

                    var corrales = localStorage.getItem('corrales')
                    corrales = JSON.parse(corrales)
                    for (let i = 0; i < corrales.length; i++) {
                        if (corrales[i]['id'] == this.idcorral) {
                            if (this.corral == '') {
                                this.corral = corrales[i]['corral']
                            }
                        }
                    }

                    this.http.get(resource.route + '/semanas/' + this.idcorral).subscribe(
                        (data: any) => {
                            if (data.length == 0) {
                                this.semana = 1
                            } else {
                                this.semana = data[0]['semana'] + 1;
                            }
                            this.capturarSTD()
                            resource.updateLocalStorageFromOnline()
                        },
                        error => {
                            var semanas = localStorage.getItem('semanas')
                            semanas = JSON.parse(semanas)
                            this.semana = 1
                            for (let i = 0; i < semanas.length; i++) {
                                if (semanas[i]['idcorral'] == this.idcorral) {
                                    if (this.semana <= semanas[i]['semana']) {
                                        this.semana = semanas[i]['semana'] + 1;
                                    }
                                }
                            }
                            this.capturarSTD()
                        }
                    );
                }
            });
        }
    }

    ngOnInit(): void {
    }

    capturarSTD(){
        let lotes = JSON.parse(localStorage.getItem('lotes'));
        let lote = ''
        lotes.forEach(e => {
            if(e.idLote == this.idlote){
                lote = e;
            }
        });
        this.standares = JSON.parse(localStorage.getItem('stdGranja'));
        this.campoSTD = "Peso"+lote['Sexo']+"_"+lote['CodLinea']
        this.TipoGenero = lote['TipoGenero']
        this.obtenerSTD();
    }

    obtenerSTD(){
        if(this.semana <= 24){
            this.tablaSTD = 'STD';
        }else {
            if(this.TipoGenero == "LH"){
                this.tablaSTD = 'STDHem';
            }else{
                this.tablaSTD = 'STDMac';
            }
        }
        let STD = this.standares[this.tablaSTD];
        let valor = 0;
        STD.forEach(e => {
            if(this.tablaSTD == 'STD'){
                if(e.Semana == this.semana){
                    valor = e[this.campoSTD]
                }
            }else{
                if(e.Semana == this.semana){
                    valor = e[this.campoSTD]
                }
            }
        });
        this.STD = valor;
    }

    confirm(texto) {
        this.alert_message = texto;
        var elem = document.querySelector('#modal1');
        this.instance = M.Modal.init(elem);
        this.instance.open();
    }

    error(texto){
        this.alert_message = texto;
        var elem = document.querySelector('#modal2');
        this.instance = M.Modal.init(elem);
        this.instance.open();
        setTimeout(() => {
            this.instance.close();
        }, 2000);
    }

    close() {
        this.instance.close();
    }

    numberWithCero(number) {
        if (number < 10) {
            return '0' + number.toString()
        } else {
            return number.toString()
        }
    }

    simular() {
        let cantidad = prompt('Cuantos quieres generar');
        var numero = 0.0
        var min = 1000
        var max = 5000
        if (Number(cantidad)) {
            var orden = $('#orden').val()
            for (let i = 0; i < Number(cantidad); i++) {
                numero = Math.floor(Math.random() * (max - min + 1) + min);

                orden++;
                $('#aves tbody').append('<tr>' +
                    '<td>' + orden + '</td>' +
                    '<td>' +
                    '<input type="number" name="pesos" id="ave-' + orden + '" placeholder="Agregar peso" value="' + numero + '">' +
                    '</td>' +
                    '</tr>')
            }
            $('#orden').val(orden)
            $('#ave-' + orden).focus()
        }
    }

    registrarNext() {
        this.registrar("si")
    }

    reset() {
        this.semana = Number(this.semana) + 1
        $('#orden').val(0)
        $("#aves tbody").html("")
    }

    registrar(continuar = "no") {
        let message = ''
        if(this.semana == null){
            message = 'Revise el valor de la semana.'
            this.error(message)
            return;
        }
        var aves = [];
        for (let i = 0; i < this.avesArray.length; i++) {
            const e = this.avesArray[i];
            aves.push(e.peso)
        }
        if (aves.length == 0) return;
        let enviarData = true;
        for (let i = 0; i < aves.length; i++) {
            const a = aves[i];
            if(isNaN(a) || a == "" || a == 0){
                enviarData = false
                message = 'No pueden existir campos vacíos o con valor 0.'
            }
        }
        if(aves.length < 4){
            enviarData = false;
            message = 'La cantidad de aves no puede ser menor que 4.'
        }
        if(enviarData == true){
            this.btnGuardar = false;
            var semana_data = {
                id: uuidv4(),
                aves: aves,
                semana: this.semana,
                idcorral: this.idcorral,
                idLote : this.idlote,
                user : this.user
            }
            return this.http.post(this.resource.route + '/semanas/', semana_data).subscribe(
                (data: any) => {
                    if (continuar == "no") {
                        this.router.navigate(['/pesajes/' + this.idlote + "/" + this.idcorral]);
                    } else {
                        this.reset()
                    }
                },
                error => {
                    var falta_json = localStorage.getItem('falta_subir')
                    if (falta_json == '' || falta_json == undefined) {
                        this.falta_subir = []
                    } else {
                        this.falta_subir = JSON.parse(falta_json)
                    }
                    this.falta_subir.push(semana_data)
                    localStorage.setItem('falta_subir', JSON.stringify(this.falta_subir));
    
                    var suma = 0
                    for (let i = 0; i < semana_data['aves'].length; i++) {
                        suma = suma + semana_data['aves'][i]
                    }
                    var promedio = suma / semana_data['aves'].length;
                    var today = new Date();
                    var date = today.getFullYear() + '-' + this.numberWithCero(today.getMonth() + 1) + '-' + this.numberWithCero(today.getDate());
                    var time = this.numberWithCero(today.getHours()) + ":" + this.numberWithCero(today.getMinutes()) + ":" + this.numberWithCero(today.getSeconds());
                    var dateTime = date + 'T' + time;
                    var nueva_semana = {
                        id: semana_data.id,
                        idsemana: semana_data.id,
                        detalle: semana_data.aves,
                        semana: this.semana,
                        promedio: parseFloat(promedio.toFixed(2)),
                        aves: semana_data['aves'].length,
                        idcorral: this.idcorral,
                        fecha_creacion: dateTime + ".000Z",
                        corral: this.corral,
                        idlote: this.idlote,
                        user : this.user,
                        online: 0
                    }
                    this.semana_offline = localStorage.getItem('semanas')
                    this.semana_offline = JSON.parse(this.semana_offline)
                    this.semana_offline.push(nueva_semana)
                    localStorage.setItem('semanas', JSON.stringify(this.semana_offline));
                    if (continuar == "no") {
                        this.router.navigate(['/pesajes/' + this.idlote + "/" + this.idcorral]);
                    } else {
                        this.reset()
                    }
                }
            );
        }else{
            this.error(message)
        }
    }

    saltar(pos){
        if(pos == 'ultimo'){
            this.avesArray.push({
                peso : 0
            });
            pos = (this.avesArray.length-2)
        }else{
            if((pos+1) == this.avesArray.length){
                this.avesArray.push({
                    peso : 0
                });
            }
        }
        setTimeout(() => {
            $('#ave-'+(pos+1)).focus()
        }, 40)
    }

    changeValueAve(event, pos){
        this.avesArray[pos].peso = Number(event.target.value);
    }

    eliminarAve(pos){
        this.avesArray.splice(pos, 1);
    }

    agregarAve() {
        // let orden = $('#orden').val()
        // orden++;
        // $('#aves tbody').append('<tr>' +
        //     '<td>' + orden + '</td>' +
        //     '<td>' +
        //     '<input type="number" name="pesos" id="ave-' + orden + '" placeholder="Agregar peso">' +
        //     '</td>' +
        //     '<td>'+
        //     '<button class="btn red" (click)="eliminarAve()">-</button>'+
        //     '</td>'+
        //     '</tr>')
        // $('#orden').val(orden)
        // $('#ave-' + orden).focus()
    }

    changeSemana() {
        if(this.semana != null){
            this.obtenerSTD()
        }
    }

    cancelar() {
        this.confirm('¿Seguro que deseas cancelar el registro?')
    }
    confirmar() {
        this.router.navigate(['/pesajes/' + this.idlote + "/" + this.idcorral]);
    }
    regresar() {
        this._location.back();
    }

}
